import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useApi } from "@shopexperts/shared";

export function useGeoRegions() {
  const api = useApi();

  const query = useQuery({
    queryKey: ["geo-regions"],
    queryFn: () => api.geoRegions?.getGeoRegions ? api.geoRegions.getGeoRegions() : Promise.resolve([]),
    staleTime: 60 * 60 * 1000,
  });

  const options = computed(() =>
    (query.data.value ?? [])
      .slice()
      .sort((a, b) => a.sort_index - b.sort_index)
      .map((region) => ({
        label: region.label,
        value: region.slug,
      }))
  );

  return {
    ...query,
    options,
  };
}

export default useGeoRegions;
